<form [formGroup]="form">
  <h4 i18n>Verify your email address</h4>
  <p><span i18n>Please check your email</span><strong> {{ contact.email }} </strong><span i18n>for a verification code. If you don't see it, please check your spam folder.</span></p>
  <p><a href="javascript:void(0)" (click)="resend()" i18n>Resend verification code</a></p>
  <div class="form-group">
    <label for="code" class="form-label" i18n>Verification code</label>
    <input type="text" class="form-control" formControlName="code" id="code" placeholder="Enter verification code" i18n-placeholder>
  </div>
  <div class="col-12 mt-3">
    <button type="button" class="btn btn-primary w-100" (click)="save()"  i18n>Verify</button>
  </div>
</form>